export enum EPartnerTabsEdit {
  DadosParceiro = 1
}
